var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/IssueCommentType.enum.ts";
export var IssueCommentType;
(function (IssueCommentType) {
  IssueCommentType["CHANGE_ANSWER"] = "CHANGE_ANSWER";
  IssueCommentType["ISSUE_COMMENT"] = "ISSUE_COMMENT";
})(IssueCommentType || (IssueCommentType = {}));